import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import ProductsList from "components/menu/master-files/product-maintenance/list";

const ProductMaintenanceRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={ProductsList}
            />
        </Switch>
    </div>
);

export default connect()(ProductMaintenanceRouter);
